import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core'
import {
  AnswerControls,
  MultiAnswerControls,
  Options,
  SelectOptions,
  SingleAnswerControls,
  StepperOptions,
} from './dynamic-form'
import {takeUntil} from 'rxjs/operators'
import {Subject} from 'rxjs'
import {DynamicForm} from './dynamic-form.model'
import {FormArray, FormControl} from '@angular/forms'

@Component({
  selector: 'bgo-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormComponent implements OnInit, OnDestroy {
  @Input() dynamicForm!: DynamicForm
  @Input() verticalSpacing: 'normal' | 'small' = 'normal'
  @Input() labelPosition: 'top' | 'control' = 'top'

  private unsubscribe$ = new Subject<void>()

  constructor(private cdr: ChangeDetectorRef) {}

  asSingleAnswerControls(answer: AnswerControls) {
    return answer as SingleAnswerControls
  }

  asSingleAnswerControl(answer: AnswerControls) {
    return this.asSingleAnswerControls(answer).answer as FormControl
  }

  asMultiAnswerControls(answer: AnswerControls) {
    return answer as MultiAnswerControls
  }

  asMultiAnswerControl(answer: AnswerControls) {
    return this.asMultiAnswerControls(answer).answers as FormArray
  }

  ngOnInit(): void {
    this.dynamicForm.onTouched$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.cdr.markForCheck()
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  stepperOptions(options?: Options): StepperOptions {
    const stepperOptions = options as StepperOptions
    if (!Number.isInteger(stepperOptions?.max) || !Number.isInteger(stepperOptions?.min)) {
      throw Error('Type of StepperOptions was expected but not found')
    }

    return stepperOptions
  }

  selectOptions(options?: Options): SelectOptions {
    const selectOptions = options as SelectOptions
    if (!selectOptions?.length) {
      throw Error('Type of SelectOptions was expected but not found')
    }
    return selectOptions
  }
}
